<div class="header-search-bar full-container">
  <div class="container-wrapper">
    <div class="d-flex justify-content-between track-ticket-wrapper">
      <a href="./">
        <img _ngcontent-rfy-c24="" aria-label="5paisa Logo" src="https://images.5paisa.com/Campaign/5paisa-logo.svg" alt="5paisa Logo" title="5paisa Logo">
      </a>

      <!-- <span *ngIf="isLoggedIn == 'Y' && !showLoader" class="track-ticket" (click) = "clientPersonalDetails()">Track Ticket</span> -->
      <!-- <span *ngIf="isLoggedIn == 'Y'" class="track-ticket" onclick="openTicketsTab()">Track Ticket</span> -->
      <button type="button" *ngIf="isLoggedIn == 'Y'" class="track-ticket" (click)="openTicketAndCleverTapEvent()">Track Ticket</button>

      <div class="loading-text" *ngIf="showLoader" >
        <h1 class="loading">Loading
          <span class="dot-one"> .</span>
          <span class="dot-two"> .</span>
          <span class="dot-three"> .</span>
        </h1>
      </div>


    </div>
    
  <h1 class="fw-500 text">
    <ng-container *ngIf="userName && userName.trim() !== ''">
      Hi <span style="color: #a40e3d;">{{userName | titlecase}},</span>
    </ng-container>
    How can we help you?
  </h1>
  <div class="form-tab">
    <label for="faq-search-input" class="search-label">Search for FAQs</label>
    <div class="search-field d-flex position-relative w-100">
      <span class="icon-search" aria-hidden="true"></span>
      <form [formGroup]="searchForm" novalidate>
        <input autocomplete="off" type="text" pattern="^[a-zA-Z0-9?]*$" name="search" id="faq-search-input" class="text-field"
          placeholder="Search for your questions" formControlName="searchText" (keyup)="searchByString()" (keypress)="omit_special_char($event)"
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="showResults"
          aria-controls="faq-search-results"
          aria-describedby="search-hint"
          (keydown)="onSearchInputKeydown($event)"/>
        <ul id="faq-search-results" class="results" *ngIf="showResults && searchListArray.length" role="listbox" aria-label="Search results">
          <li *ngFor="let item of searchListArray; index as i" role="option">
            <button type="button"
              class="result-item"
              *ngIf="isSearchResultItem(item)"
              [attr.id]="'search-result-' + i"
              (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink, item.title)"
              (keydown)="onResultKeydown($event, i)">
              {{ item.title }}
            </button>
            <span *ngIf="item === constantService.noResultFoundText" class="result-empty">{{ item }}</span>
          </li>
        </ul>
        <span id="search-hint" class="visually-hidden">Type to search frequently asked questions</span>
      </form>
    </div>
  </div>
</div>
</div>